import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'reports.gridreport',
  path: '/reports/grid-report',
    title: 'Grid Report',
    component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);